import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { normalizeLocale } from '../i18n/locales';

/** Current app locale (en | pt | fr | es). */
export function useAppLocale() {
  const { i18n: inst } = useTranslation();
  return normalizeLocale(inst.language);
}

/** Read locale synchronously (for API payloads outside React). */
export function getAppLocale() {
  return normalizeLocale(i18n.language);
}

export default useAppLocale;
